module.exports = __webpack_public_path__ + "img/landing.dd201a19.png";